import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getOfflineCourseList,
  getOfflineCourseListByPost
} from "../../api/service.js"

import {
  getUnderlineCourseDetail,
  saveUnderlineRegisterCourse
} from '../../apiCloud/offlineApply'

import {
  pUrl
} from "@/api/baseURL.js";
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    var validateIDnumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入身份号不能为空'));
      } else {
        if (value.length != 18 && value.length != 15) {
          callback(new Error('请输入15/18位正确的身份证号'));
        } else {
          callback()
        }
      }
    }
    var validateTelPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        if (!Number.isInteger(value) && value.length != 11) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback()
        }
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('QQ/邮箱不能为空'));
      } else {
        callback()
      }
    };
    return {
      form: {
        name: '',
        sex: '0',
        telPhone: '',
        IDnumber: '',
        email: '',
        job: '',
        skill: '',
        trainPerson: '',
        trainTel: '',
        unitName: '',
        address: '',
      },
      rules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        IDnumber: [{
          required: true,
          validator: validateIDnumber,
          trigger: 'blur'
        }],
        telPhone: [{
          required: true,
          validator: validateTelPhone,
          trigger: 'blur'
        }],
        email: [{
          required: true,
          validator: validateEmail,
          trigger: 'blur'
        }]
      },
      courseName: '',
      courseId: '',
      value: '',
      isJx: false,
    }
  },
  created() {
    console.log(this.$route.query)
    if (this.$route.query.courseId) {
      localStorage.setItem("courseId", this.$route.query.courseId)
    }
    this.courseId = localStorage.getItem("courseId")
    this.getCourseDetail()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    // var pUrl=window.location.href;
    // // 是否是江西代理商访问
    //     if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //     console.log(1111,this.isJx)
    //     this.isJx=true;
    // }
  },
  mounted() {
    var publicCourse = document.getElementsByClassName("offlineApply")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = "enterprise/underline/saveUnderlineRegisterCourse"
          let data = {
            registerName: this.form.name,
            registerSex: this.form.sex,
            registerPhone: this.form.telPhone,
            registerIdcard: this.form.IDnumber,
            registerEmail: this.form.email,
            registerPosition: this.form.job,
            technicalTitle: this.form.skill,
            trainingName: this.form.trainPerson,
            trainingPhone: this.form.trainTel,
            registerEnterprise: this.form.unitName,
            registerAddress: this.form.address,
            courseId: this.courseId
          }
          // console.log(888,data)
          saveUnderlineRegisterCourse(data).then(res => {
            if (res.code==200) {
              // $("#submitButton").attr("disabled",'disabled')
              let _this = this
              this.$message({
                message: '恭喜你，报名成功！',
                type: 'success'
              })
              setTimeout(() => {
                this.$router.push({
                  path: "/offlineCourseList",
                });
              }, 2000)

            }
            if (res.code == 1) {
              this.$message({
                message: res.message,
                type: 'warning'
              })
            }
          })

        } else {
          this.$message.error('请检查红色提示部分');
          return false;
        }
      })

    },
    getCourseDetail() {
      let data = {
        courseId: this.courseId,
        entpId: localStorage.getItem("enterpriseId")
      }
      getUnderlineCourseDetail(data).then(res => {
        if (res.code==200) {
          this.courseName = res.data.courseName
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/offlineApply/offlineApply.js